<template>
<div>
    <div class="container" v-show="!flag">
        <!-- 个人信息部分 -->
        <div class="header">
            <p class="title">{{productName1}}</p>
            <p class="content">({{productName2}})</p>
            <!-- 测评者头像 -->
            <img :src="portrait" alt="" class="avatar">
            <div class="name">{{testerName}}</div>
            <div class="comprehensive">
                <span>综合指数：</span>
                <div class="mark">
                    <div class="mark_blank">
                            <img src="../assets/images/组 1000@2x.png" alt="" v-for="(item,index) in fullStar" :key="index+Math.random()*10">
                            <img src="../assets/images/half.png" alt="" v-for="(item,index) in halfStar" :key="index+Math.random()*10">
                            <img src="../assets/images/组 7546@2x.png" alt="" v-for="(item,index) in (5 - halfStar - fullStar)" :key="index+Math.random()*10">
                    </div>
                </div>
            </div>
            <ul class="info" >
                <li v-if="testerInfo.testerSex" :style=" {width:100/liWidth - 1 + '%'}">
                    <div>性别</div>
                    <div>
                        <p class="sex">{{testerInfo.testerSex}}</p>
                    </div>
                </li>
                <li v-if="testerInfo.school" :style=" {width:100/liWidth - 1 + '%'}">
                    <div>学校</div>
                    <div>
                        <p class="sex">{{testerInfo.school}}</p>
                    </div>
                </li>
                <li v-if="testerInfo.major" :style=" {width:100/liWidth - 1 + '%'}">
                    <div>专业</div>
                    <div>
                        <p class="sex">{{testerInfo.major}}</p>
                    </div>
                </li>
                <li v-if="testerInfo.startDate" :style=" {width:100/liWidth - 1 + '%'}">
                    <div>测试日期</div>
                    <div>
                        <p class="sex">{{testerInfo.startDate}}</p>
                    </div>
                </li>
            </ul>
            <!-- 悬浮框 -->
            <div class="suspended">
                <div class="guide" @click="suspended()">阅读指南</div>
                <div class="answer" @click="validAnswer()">答题情况</div>
            </div>
        </div>
        <div class="main">
            <div class="main_bgc1"></div>
            <div class="main_bgc3"></div>
            <div class="main_bgc4"></div>
            <!-- 一级指标 -->
            <div class="first_content">
                <!-- 是否有效图显示 -->
                <img src="../assets/images/组 7016@3x.png" alt="" class="result" v-if="validQues === 1">
                <img src="../assets/images/组 7783@2x.png" alt="" class="result" v-if="validQues === 2">
                <p class="title">测评结果</p>
                <div class="radar">
                    <div class="sore">
                        <div class="comprehensive">综合得分</div>
                        <div class="fraction">{{finalScore}}</div>
                    </div>
                    <div class="chart">一级指标雷达图</div>
                    <div id="echartContainer" ref="refs" style="width:100%; height:266px" class="echarts_radar"></div>
                    <div class="echarts_explanation">
                        <div class="average">
                                <div></div>
                                <div>标杆人群得分平均值</div>
                        
                        </div>
                        <div class="average">
                                <div class="average_line"></div>
                                <div>测试结果</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 二级指标 -->
            <div class="second_content">
                <div class="second_all">
                    <div class="second_title">二级指标曲线图</div>
                    <div class="second_echarts">
                        <canvas id="chart">
                            Your browser does not support the HTML5 canvas tag.
                        </canvas>
                    </div>
                    <div class="echarts_explanation">
                        <div class="average">
                            <div></div>
                            <div>标杆人群得分平均值</div>
                    
                    </div>
                    <div class="average">
                            <div class="average_line"></div>
                            <div>测试结果</div>
                    </div>
                    </div>
                </div>

                <!-- 二级指标细化内容 -->
                <div class="second_details">
                    <p class="second_explanation">详细解释</p>
                    <div class="communication">
                        <!-- navbar -->
                        <div class="communication-shadow">
                            <mt-navbar v-model="selected">
                                <mt-tab-item :id="item.id" v-for="(item,index) in details" :key="item.id">
                                        <span>{{index}}</span>
                                        <span class="second_score">({{item.overallScore.toFixed(1)}}分)</span>
                                </mt-tab-item>
                            </mt-navbar>
                        </div>
                        <!-- tab-container -->
                        <mt-tab-container v-model="selected">
                            <mt-tab-container-item :id="item.id" v-for="item in details" :key="item.id">
                                <div class="detail" v-for="(ind,con) in item.secondLevelDimension" :key="ind.id">
                                    <div class="tab_score">{{con}}</div>
                                    <div class="tab_content">
                                        <span class="score" :style="{marginLeft: -71 + ind.score * 14.2 - (ind.score > 5 ? 0 : 2) + '%' , top: Math.floor((clientWid*0.70)/6) - ind.score * Math.floor((clientWid*0.70)/6)/10 + 'px'}">{{ind.score}}</span>
                                        <!-- 灰色音量图 -->
                                        <div class="tab_chart0">
                                            <div v-for="(item,height) in Math.floor((clientWid*0.70)/6)" :key="item" style="width:3px;display: inline-block;margin-right:3px;background-color: #F0F0F0;;vertical-align: bottom" :style="{height: height+'px'}" class="tab_limit">
                                            </div>
                                        </div>
                                        <!-- 彩色音量图 -->
                                        <div class="tab_chart1" :style="{marginTop: -Math.floor((clientWid*0.70)/6) + 1 + 'px',width: ind.score * 10 * 0.75 + '%',marginLeft:'12.3%'}">
                                            <div v-for="(item,height) in Math.floor((clientWid*0.70)/6)" :key="item" style="width:3px;display: inline-block;margin-right:3px;vertical-align: bottom"  :style="{height: height+'px',backgroundColor: 'rgb(' + (92 - height * 30 / Math.floor((clientWid*0.70)/6)) + ',' + (206 - height * 88 / Math.floor((clientWid*0.70)/6)) +',' + (233 - height * 30/ Math.floor((clientWid*0.70)/6))+')'}" class="tab_height">
                                            </div>
                                        </div>
                                        <!-- 高分和低分 -->
                                        <div class="tab_both">
                                            <div>低分</div>
                                            <div>高分</div>
                                        </div>
                                        <!-- 低/高分特征 -->
                                        <div class="property">
                                            <div class="low">{{item.secondLevelDimension[con].explain.低分特征}}</div>
                                            <div class="high">{{item.secondLevelDimension[con].explain.高分特征}}</div>
                                        </div>
                                        <!-- 结论 -->
                                        <div class="conclusion">
                                            <div class="conclus">结论：</div>
                                            <div class="conclus_content">{{item.secondLevelDimension[con].explain.一般描述}}</div>
                                        </div>
                                    </div>
                                </div>
                            </mt-tab-container-item>
                        </mt-tab-container>
                    </div>
                </div>
            </div>
            <!-- 分析与建议部分 -->
            <div class="third_content">
                <div class="bgc5"></div>
                <div class="third_title">分析与建议</div>
                <div class="thirdContent">
                    <!-- navbar -->
                    <div class="thirdContent_shadow">
                        <mt-navbar v-model="sugDetails">
                            <mt-tab-item id='0'>
                                    <span>突出表现</span>
                            </mt-tab-item>
                            <mt-tab-item id='1'>
                                    <span>不足表现</span>
                            </mt-tab-item>
                            <mt-tab-item id='2'>
                                    <span>发展与培养建议</span>
                            </mt-tab-item>
                        </mt-navbar>
                    </div>
                    <!-- tab-container -->
                    <mt-tab-container v-model="sugDetails" class="th_content">
                        <mt-tab-container-item id='0'>
                            <div class="thirdContent_detail" v-for="item in proScore" :key="item.id">
                                <span class="thirdContent_tilte">{{item.name}}：</span> {{item.explain.高分特征}}
                            </div>
                        </mt-tab-container-item>
                        <mt-tab-container-item id='1'>
                            <div class="thirdContent_detail" v-for="item in shortScore" :key="item.id">
                                <span class="thirdContent_tilte">{{item.name}}：</span> {{item.explain.低分特征}}
                            </div>
                        </mt-tab-container-item>
                        <mt-tab-container-item id='2'>
                            <div class="thirdContent_detail" v-for="item in suggest" :key="item.id">
                                <span class="thirdContent_tilte" v-if="item.explain.发展与培养建议">{{item.name}}：</span> {{item.explain.发展与培养建议}}
                            </div>
                        </mt-tab-container-item>
                    </mt-tab-container>
                </div>
            </div>
        </div>
        <!-- 阅读指南 -->
        <div class="readingguide" v-show="guide_flag" ref="ceshi">
            <div class="down" @click="suspended()">
                <img src="../assets/images/箭头@2x.png" alt="">
            </div>
            <div class="readingguide_explanation">
                <div class="explanation_title">
                    报告阅读指南
                </div>
                <div class="introduction">介绍</div>
                <div class="introduction_content">
                    <p style="text-indent:2em; text-align: justify; margin-top:10px">人力资源是企业最宝贵的资源，企业组织要在全球化挑战中保持竞争优势，必须拥有一流的人力资 源。人力资源管理的核心理念就是要把正确的人放到正确的岗位上，做到“人-职”匹配，人尽其才， 其前提就是必须对人和职位进行科学准确分析。</p>
                    <p style="text-indent:2em; text-align: justify; margin-top:8px">借助胜任素质模型和工作分析方法，可以对从事不同岗位的人员的能力素质进行全面分析，确定岗位所需要的胜任素质;借助现代人才测评技术，可以对不同的人员的潜能进行评价，帮助企业组织找到真正胜任的人员。</p>
                    <p style="text-indent:2em; text-align: justify; margin-top:8px">氪创教育通过对中国企业组织岗位胜任素质模型和职位说明书的全面研究和梳理，结合中国人能力素质和心理潜能的结构特点，依托一流的国际化专业研发团队，历时多年研究，严格筛选测评题目、确定测评模型、制定常模，精心开发出适合中国人特点的潜能测评系列产品。</p>
                    <p style="text-indent:2em; text-align: justify; margin-top:8px">氪创教育潜能测评产品覆盖了专业人员、应届毕业生、管理培训生、职业经理人、领导干部等的招聘选拔、内部竞聘、素质盘点、发展培养、生涯规划等众多领域，全面助力企业组织甄选到最适合的人才，提升组织人力资源的质量，在激励的市场竞争中永葆基业常青。</p>
                    <p style="text-indent:2em; text-align: justify; margin-top:8px">氪创教育依托云计算平台，在中国人才测评软件领域处于领先水平，帮助企业组织提高人才测评的质量和效率。</p>
                </div>
                <div class="recommendations">
                    阅读本测评报告建议
                </div>
                <div class="recommendations_content">
                    <p style="text-indent:2em; text-align: justify; margin-top:8px">1）首先，请根据被测评者答题的情况，包括：答题时间、完成题目数量、答题过程中的社会称许 性（或掩饰性）等指标来判断本测评结果是否真实有效。</p>
                    <p style="text-indent:2em; text-align: justify; margin-top:8px">2）其次，本测评结果的分数为依据常模样本分数分布而得到的标准十分 (Sten Score)，该分数代 表了被测评者在常模人群中所处的位置，分数越高，代表被测评者的位置越靠前，其中标准十分的最高 分10，最低分为1，平均分为5.5，标准差为2，如果一个人的分数正好为5.5，表明其正好处于常模人群 的平均得分上，这样，常模人群中各有50%的人的分数高于或低于此人的分数。</p>
                    <p style="text-indent:2em; text-align: justify; margin-top:8px">Sten分数与 <span class="grade_word">百分等级</span> 分述的对应关系如下表所示：</p>
                    <div class="tabel">
                        <div class="grade">
                            <div>Sten <p></p> 分数</div>
                            <div>百分<p></p>等级</div>
                        </div>
                        <div class="grade">
                            <div>1</div>
                            <div>1-2</div>
                        </div>
                        <div class="grade">
                            <div>2</div>
                            <div>3-7</div>
                        </div>
                        <div class="grade">
                            <div>3</div>
                            <div>8-16</div>
                        </div>
                        <div class="grade">
                            <div>4</div>
                            <div>17-31</div>
                        </div>
                        <div class="grade">
                            <div>5</div>
                            <div>32-500</div>
                        </div>
                    </div>
                    <div class="tabel1">
                        <div class="grade1">
                            <div>6</div>
                            <div>51-69</div>
                        </div>
                        <div class="grade1">
                            <div>7</div>
                            <div>70-84</div>
                        </div>
                        <div class="grade1">
                            <div>8</div>
                            <div>85-93</div>
                        </div>
                        <div class="grade1">
                            <div>9</div>
                            <div>94-98</div>
                        </div>
                        <div class="grade1">
                            <div>10</div>
                            <div>99-100</div>
                        </div>
                        <div class="grade1">
                            <div>Sten <p></p> 分数</div>
                            <div>百分<p></p>等级</div>
                        </div>
                    </div>
                    <p style="text-indent:2em; text-align: justify; margin-top:255px">3）请结合所有测评维度的分数分布情况综合地看待测评结果，而不要孤立地局限于某一维度上的得分。 </p>
                    <p style="text-indent:2em; text-align: justify; margin-top:8px">4）请认真阅读报告中各测评维度的高分和低分特征来理解各测评维度的真实含义，而不要凭个人的猜测来认识测评维度。 </p>
                </div>
            </div>
        </div>
        <!-- 答题情况 -->
        <div class="answers" v-show="effective_flag" ref="effective">
            <div class="down" @click="validAnswer()">
                <img src="../assets/images/箭头@2x.png" >
            </div>
            <div class="readingguide_explanation">
                <div class="explanation_title">
                    答题情况
                </div>
                <div class="introduction">问卷有效性分析</div>
                <div class="introduction_content">
                    请注意：本部分将根据{{testerName}}在测试过程中的答题总时间、完成题目数量、社会称许性得分情况，对{{testerName}}的测试结果的有效性进行判断。
                </div>

                <div class="slider">
                    <!-- 答题总时间 -->
                    <div class="answer_time">
                        <div class="answer_word">答题总时间:</div>
                        <div class="time">
                            <div class="interval">
                                <div class="validInterval"></div>
                            </div>
                            <div class="effectiveTime">
                                <div class="effective_star">{{this.timeLimit/2}}分钟</div>
                                <div class="effective_stop">{{this.timeLimit*2}}分钟</div>
                            </div>
                            <!-- 测评者结果 -->
                            <div class="litigant" ref="testResult"></div>
                        </div>
                    </div>
                <!-- 完成题目量 -->
                <div class="question">
                        <div class="question_title">完成题目量: </div>
                        <div class="question_con">
                            <div class="question_interval">
                                <div class="question_validInterval"></div>
                            </div>
                            <div class="question_effectiveTime">
                                <div class="question_effective_star">97%</div>
                                <div class="question_effective_stop">100%</div>
                            </div>
                            <!-- 测评者结果 -->
                            <div class="testerComp" ref="testComplete"></div>
                        </div>
                    </div>
                    <!-- 掩饰得分 -->
                    <div class="lie">
                        <div class="lie_title">掩饰性得分: </div>
                        <div class="lie_con">
                            <div class="lie_interval">
                                <div class="lie_validInterval"></div>
                            </div>
                            <div class="lie_effectiveTime">
                                <div class="lie_effective_start">0分</div>
                                <div class="lie_effective_stop">8分</div>
                            </div>
                            <div class="lieSc" ref="lieScore"></div>
                        </div>
                    </div>
                </div>

            <div class="parameter">
                <div class="average">
                            <div></div>
                            <div>有效区间</div>
                    
                    </div>
                    <div class="average">
                            <div class="average_line"></div>
                            <div>测试者结果</div>
                    </div>
            </div>

                <div class="effectiveness">
                    <span>有效性综合评价：</span >
                    <span v-if="validQues===1">{{testerName}}测验结果有效</span>
                    <span v-if="validQues===2" style="color:#f54252;">{{testerName}}测验结果无效</span>
                </div>
                
                <div class="ansewrTime">问卷各部分答题时间</div>

                <div class="form">
                    <div class="form_head">
                        <div>序号</div>
                        <div>问卷名称</div>
                        <div>答题耗时</div>
                        <div>预设答题时间</div>
                    </div>
                    <div class="form_body" v-for=" (item,index) in questionnaires" :key="index">
                        <div>{{index+1}}</div>
                        <div>{{item.name}}</div>
                        <div>{{item.elapsedTime}}分钟</div>
                        <div>{{item.timeLimit}}分钟</div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div v-show="flag"  v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="拼命加载中" style="margin: 300px auto 0;text-align: center;">
        {{error}}
    </div>
</div>
</template>
<script>
const  echarts = require('echarts')
// 引用微信的SDK
import wx from 'weixin-js-sdk' 
import { config } from "../config";
export default {
    data() {
      return {
        unionId:'',
        domainId:'',
        candidateId:'',
        portrait:'',        //头像
        productName:'',     //测评名称
        productName1:'',   //测评名称前部分
        productName2:'',   //测评名称后部分
        testerName:'',              //测试者姓名
        testerInfo:{},           //测试者信息
        composite:'',           //综合指数
        validQues:'',           //判断测评是否有效 1:有效 2:无效
        questionnaires:{},      //测评共有几部分
        detailsData:[],         //雷达图数据
        details:{},             //一级指标详细得分
        finalScore:'',                  //最终得分  综合得分
        fullStar:'',            //满星星数
        halfStar:'',            //半星星数
        lieScore:0,                    //掩饰得分
        reportModels:{},                 //一级指标
        firstBenchmark:[],              //一级指标人群得分平均值
        secondBenchmark:[],             //二级指标人群得分平均值
        overallScore:[],                //一级指标测试者分数
        secondData: [],                //二级指标测试者分数
        activeName: 'first',             //分析与建议默选第一个
        guide_flag:false,                //报告指南是否展现  
        effective_flag:false,           //答题情况展示
        scrollTop:'',                   //屏幕滑动距离
        clientWid:'',                    //屏幕body的宽度
        timeLimit:0,                    //测评规定总时间
        completion: 0,                  //测评完成度
        testerLimit:0,                  //测评者总耗时
        analysisData:[],                 //分析数据
        proScore:[],                     //突出表现
        shortScore:[],                   //不足表现
        suggest:[],                     //发展与建议
        selected: '',                    //二级指标详细默认选项
        sugDetails:'0',                 //分析与建议默认选择
        liWidth:0,
        flag:true,
        fullscreenLoading:true,
        error:''
      }
    },
    mounted(){
        this.getData()
    },
    methods:{
        getData(){
            if(this.$route.params.unionId.indexOf("=") != -1 && this.$route.params.Id.indexOf("=") != -1){
                this.unionId = this.$route.params.unionId.split('=')[1]
                if(this.$route.params.Id.indexOf("candidateId") != -1){
                    this.candidateId = this.$route.params.Id.split("=")[1]
                }else{
                    this.domainId = this.$route.params.Id.split('=')[1]
                }
            }else{
                this.unionId = this.$route.params.unionId
                if(this.unionId.indexOf("&") != -1){
                    this.unionId = this.unionId.split('&')[0]
                }
                
                if(this.$route.params.domainId !== undefined){
                    this.domainId = this.$route.params.domainId
                }else if(this.$route.params.candidateId !== undefined){
                    this.candidateId = this.$route.params.candidateId
                }
            }
            this.requesData();
        },
        // 请求所需数据
        requesData(){
            document.title = '人才素质测评报告'
            var url = this.candidateId !== '' ? config.CandidateAQCAUrl : config.StuAQCAUrl
            var params = this.candidateId !== '' ? {candidateId: this.candidateId} : { domainId : this.domainId}
            var headers = this.candidateId !== '' ? {hrUnionId: this.unionId,'Cache-Control': 'no-cache'} : { stuUnionId : this.unionId,'Cache-Control': 'no-cache'}
            window.addEventListener('scroll', this.handleScroll);
            this.axios.get(url,{
                params,
                headers:headers
            }).then(res =>{
                if(res.status === 200){
                    
                    var data = res.data
                    this.portrait = config.fileUrl + data.profile.portrait
                    this.productName = data.productName;               //测评名称
                    this.testerName = data.profile.name;            //测评者姓名
                    this.testerInfo.testerSex =  data.profile.gender === 1 ? '男' : '女';   //测评者性别
                    this.testerInfo.startDate = this.formatDate(new Date(data.startDate)).substring(0,this.formatDate(new Date(data.startDate)).length - 8);     //开始测评时间
                    this.testerInfo.school =  data.profile.school,          //  学校
                    this.testerInfo.major =  data.profile.major,            //专业
                    this.finalScore = data.finalScore.toFixed(1);   //综合得分
                    this.fullStar = parseInt(this.finalScore/2)
                    this.halfStar = this.finalScore -parseInt(this.finalScore) > .7 ? parseInt(this.finalScore + 1)%2 : parseInt(this.finalScore)%2
                    this.validQues = data.validQues;                 //测评是否有效
                    this.lieScore = data.lieScore;                   //掩饰得分
                    this.questionnaires = data.questionnaires        //测评每部分名字和限制时间以及消耗时间
                    this.details = data.details                     //一级指标详细得分
                    this.completion = data.completion               //测评完成度

                    // 把productName拆分
                    this.productName1 = this.productName.split("（")[0]
                    this.productName2 = this.productName.split("（")[1]
                    this.productName2 = this.productName2.split("）")[0]

                    // 测评总规定时间和测试者消耗总时间
                    data.questionnaires.forEach(element => {
                        this.timeLimit += element.timeLimit;
                        this.testerLimit += element.elapsedTime
                    });
                    for (const key in this.testerInfo) {
                        if (this.testerInfo[key]) {
                            this.liWidth += 1
                        }
                    }
                    // 雷达图指示器名字显示
                    for (const key in data.details) {
                        var temObj = new Object()
                        temObj.name = key
                        temObj.max = "10"
                        this.detailsData.push(temObj)
                        this.firstBenchmark.push(data.details[key].benchmark)
                        this.overallScore.push(data.details[key].overallScore)
                        // 所有二级指标
                        var temData = data.details[key].secondLevelDimension
                        for (const key in temData) {
                            var Data = temData[key]
                            Data.name = key
                            this.analysisData.push(Data)
                        }
                    }
                    // 二级指标根据分数排序
                    this.analysisData = this.analysisData.sort(this.compare("score"))
                    // 突出表现与不足表现
                    this.analysisData.forEach(sc => {
                        if(sc.score >= 5){
                            this.proScore.push(sc)
                        }else if(sc.score < 5){
                            this.shortScore.push(sc)
                        }
                    })
                    // 发展与建议
                    this.suggest = this.shortScore
                    if(this.proScore.length > this.analysisData.length * 0.3){
                        this.proScore = this.proScore.slice(0, Math.ceil(this.analysisData.length * 0.3))
                    }
                    if(this.shortScore.length > this.analysisData.length * 0.3){
                        this.shortScore = this.shortScore.slice(-Math.ceil(this.analysisData.length * 0.3))
                    }
                    this.detailsData[0].axisLabel = {
                                                        show: true,
                                                        fontSize: 11,
                                                        color: '#05241E',
                                                        showMaxLabel: true, //不显示最大值，即外圈不显示数字30
                                                        showMinLabel: false, //显示最小数字，即中心点显示0
                                                    };
                    // 雷达图
                    this.leiFat()
                    // 折线图
                    this.lineChart()
                    this.fullscreenLoading = false
                    this.flag = false
                }else{
                    this.fullscreenLoading = false
                    this.error = '报告当前无法打开，请稍后再试！'
                }
                

            });
        },

        // 屏幕滚动距离
        handleScroll() {
            // 滚动距离
            this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop || 0,
            // 屏幕宽度
            this.clientWid = document.body.clientWidth > 768 ? 768 : document.body.clientWidth
        },

        // 雷达图
        leiFat(){
            // 基于准备好的dom，初始化echarts实例
            let doc = document.getElementById('echartContainer')
            doc.style.width=window.innerWidth+'px'
            var myChart = echarts.init(doc);
            // 绘制图表
            var chartData = {
                        radar: {
                            name: { // (圆外的标签)雷达图每个指示器名称的配置项。
                                textStyle: {
                                    fontSize: '12px',
                                    color: '#05241E',
                                }
                            },
                            axisLine: { // (圆内的几条直线)坐标轴轴线相关设置
                                lineStyle: {
                                    color: '#7C8C89',
                                    opacity:'0.3',
                                    // 坐标轴线线的颜色。
                                    width: 1,
                                    // 坐标轴线线宽。
                                    type: 'dashed',
                                    // 坐标轴线线的类型。
                                }
                            },
                            splitLine: { // (这里是指所有圆环)坐标轴在 grid 区域中的分隔线。
                                lineStyle: {
                                    color: '#7C8C89',
                                    opacity:'0.3',
                                    // 分隔线颜色
                                    width: 1,
                                    // 分隔线线宽
                                    type: 'dashed',
                                }
                            },
                            splitArea: { // 坐标轴在 grid 区域中的分隔区域，默认不显示。
                                show: true,
                                areaStyle: { // 分隔区域的样式设置。
                                    color:'#fff',
                                    // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
                                }
                            },
                        },
                        series: [{
                            type: 'radar',
                            itemStyle: { // 折线拐点标志的样式。
                                normal: { // 普通状态时的样式
                                    lineStyle: {
                                        //  type:'dashed'
                                        width: 4
                                    },
                                    opacity: 0
                                },
                                emphasis: { // 高亮时的样式
                                    lineStyle: {
                                        //  type:'dashed'
                                        // width: 2
                                    },
                                    opacity: 0
                                }
                            },
                            data: [
                                {
                                    name: '标杆人群得分平均值测试结果',
                                    value: this.firstBenchmark,
                                    // 设置区域边框和区域的颜色
                                    areaStyle: { // 单项区域填充样式
                                        normal: {
                                            opacity:0,
                                            color: '#fff', // 填充的颜色。[ default: "#000" ]
                                        }
                                    },
                                    lineStyle: { // 单项线条样式。
                                        normal: {
                                            opacity: 0.7, // 图形透明度
                                            color:'#5D83EB',
                                        }
                                    },
                                },
                                {
                                    name: '测试结果',
                                    value: this.overallScore,
                                    areaStyle: { // 单项区域填充样式
                                        normal: {
                                            opacity:0,
                                            color: '#fff' // 填充的颜色。[ default: "#000" ]
                                        }
                                    },
                                    lineStyle: { // 单项线条样式。
                                        normal: {
                                            opacity: 0.7, // 图形透明度
                                            color:'#EB5D76'
                                        }
                                    },
                                }
                            ],


                        }]
                    }
            chartData.radar.indicator = this.detailsData
            myChart.setOption(chartData);
        },

        // 折线图
        lineChart(){

            // 获取屏幕宽度
            var screenWidth = document.body.clientWidth
            var columnCount = screenWidth*.9 / 30
            var columnWidth = 120
            if(columnCount > this.analysisData.length){
                columnWidth = screenWidth * .9 / this.analysisData.length * 4
            }
            // 拿到canvas的标签
            var canvas = document.getElementById('chart')
            canvas.width = columnWidth * this.analysisData.length + columnWidth;   
            canvas.height = 1040;

            // 画布宽度实际 和 高度
            canvas.style.width = canvas.width/4 + 'px'
            canvas.style.height = canvas.height/4 + 'px'
            var ctx = canvas.getContext('2d');
            // X轴
            // ctx.beginPath();
            // ctx.moveTo(100, 1000);
            // ctx.lineTo(canvas.width + 112, 1000);
            // ctx.stroke();

            // 绘制竖线
            ctx.beginPath();
            ctx.lineWidth = 4
            ctx.strokeStyle = 'rgba(242, 242, 242, 1)'
            var temArry = Object.keys(this.details)
            var count = 100 
            for (let index = 0; index < Object.keys(this.details).length; index++) {
                var temObj = this.details[temArry[index]].secondLevelDimension
                for (let j = 1; j < Object.keys(temObj).length; j++) {
                    ctx.moveTo(count + j * columnWidth, 1000);
                    ctx.lineTo(count + j * columnWidth, 230);
                }
                ctx.moveTo(count + Object.keys(temObj).length * columnWidth, 1000);
                ctx.lineTo(count + Object.keys(temObj).length * columnWidth, 150);
                count += Object.keys(temObj).length * columnWidth
            }
            ctx.stroke()

            // 添加文字
            var len = 0     //每个一级指标含有多少个二级指标
            var leng = 0    //每个部分个数相加
            for (let i = 0; i < Object.keys(this.details).length; i++) {
                var temOb = this.details[temArry[i]].secondLevelDimension
                var temOArr = Object.keys(temOb)
                if(i > 0){leng += Object.keys(this.details[temArry[i-1]].secondLevelDimension).length}
                // 二级指标名称
                for (let j = 0; j < Object.keys(temOb).length; j++) {
                    //  二级指标分数
                    this.secondData.push(temOb[temOArr[j]].score)   
                    // 二级指标人均得分
                    this.secondBenchmark.push(temOb[temOArr[j]].benchmark === 0 ? 7 : temOb[temOArr[j]].benchmark)
                    // 二级指标详细 tabs 默认选项
                    this.selected = this.details[temArry[0]].id
                    ctx.font = "normal 44px 'PingFang SC'";
                    ctx.textAlign = 'center'
                    // 坐标系距离左边100，每个横坐标距离是112
                    if(i >= 1){
                        if(temOArr[j].length > 2){
                            var str0 = temOArr[j].substring(0,2)
                            var str1 = temOArr[j].substring(2,temOArr[j].length)
                            ctx.fillText(str0 ,leng * columnWidth + j * columnWidth + 100 + columnWidth/2, 270)
                            ctx.fillText(str1 ,leng * columnWidth + j * columnWidth + 100 + columnWidth/2, 320)
                        }else{
                            var str7 = temOArr[j].substring(0,1)
                            var str8 = temOArr[j].substring(1,temOArr[j].length)
                            ctx.fillText(str7 ,leng * columnWidth + j * columnWidth + 100 + columnWidth/2, 270) 
                            ctx.fillText(str8 ,leng * columnWidth + j * columnWidth + 100 + columnWidth/2, 320) 
                        }
                        
                    }else{
                        if(temOArr[j].length > 2){
                            var str3 = temOArr[j].substring(0,2)
                            var str4 = temOArr[j].substring(2,temOArr[j].length)
                            ctx.fillText(str3 ,j * columnWidth + 100 + columnWidth/2, 270)
                            ctx.fillText(str4 ,j * columnWidth + 100 + columnWidth/2, 320)
                        }else{
                            var str5 = temOArr[j].substring(0,1)
                            var str6 = temOArr[j].substring(1,temOArr[j].length)
                            ctx.fillText(str5 ,j * columnWidth + 100 + columnWidth/2, 270)
                            ctx.fillText(str6 ,j * columnWidth + 100 + columnWidth/2, 320)
                        }
                    }
                }
                // 一级指标名称
                ctx.font = "normal 52px 'PingFang SC'";
                ctx.textAlign = 'center'
                len = Object.keys(temOb).length
                if(i > 0){
                    if(len === 1){
                        var str9 = temArry[i].substring(0,2)
                        var str20 = temArry[i].substring(2,temArry[i].length)
                        ctx.fillText(str9 , leng * columnWidth  + 100 + len * columnWidth / 2, 130)
                        ctx.fillText(str20 , leng * columnWidth  + 100 + len * columnWidth / 2, 200)
                    }else{
                        ctx.fillText(temArry[i] , leng * columnWidth  + 100 + len * columnWidth / 2, 170)
                    }
                }else{
                    if(len === 1){
                        var str10 = temArry[i].substring(0,2)
                        var str11 = temArry[i].substring(2,temOArr[i].length)
                        ctx.fillText(str10 , leng * columnWidth  + 100 + len * columnWidth / 2, 130)
                        ctx.fillText(str11 , leng * columnWidth  + 100 + len * columnWidth / 2, 200)
                    }else{
                        ctx.fillText(temArry[i] , leng * columnWidth  + 100 + len * columnWidth / 2, 170)
                    }
                }
            }
            // 二级指标测试者分数
            this.secondData.forEach((element,index) => {
                if(index === 0){
                    ctx.beginPath();
                    ctx.lineWidth = 8
                    ctx.strokeStyle = '#EB5D76'
                    ctx.font = "normal 56px 'SF Pro Text'";
                    ctx.fillStyle = '#05241E'
                    ctx.fillText(element ,100 + columnWidth / 2, 1000 - element * 50 + 50)
                    ctx.arc(100 + columnWidth / 2 + index * columnWidth, 1000 - element * 50  - 20, 4, 0, 2 * Math.PI)
                    // X轴：每个轴距中间   Y轴：canvas高度 - 分出 * 每个分数占的高度 - 刻度高度  （减刻度占的高度可以使点在刻度数字中间）
                    ctx.moveTo(100 + columnWidth / 2, 1000 - element.score * 50 - 21)    
                }else{
                    ctx.font = "normal 56px 'SF Pro Text'";
                    ctx.fillStyle = '#05241E'
                    // 分数数字显示 低于线50
                    ctx.fillText(element  , 100 + columnWidth / 2 + index * columnWidth , 1000 - element * 50 + 50)
                    ctx.lineTo(100 + columnWidth / 2 + index * columnWidth , 1000 - element * 50 - 20);
                    ctx.arc(100 + columnWidth / 2 + index * columnWidth, 1000 - element * 50  - 20, 4, 0, 2 * Math.PI)
                }
            });
            ctx.stroke();

            // 人群得分平均值
            this.secondBenchmark.forEach((element,j) => {
                if(j === 0){
                    ctx.beginPath();
                    ctx.lineWidth = 8
                    ctx.strokeStyle = '#5D83EB'
                    ctx.moveTo(100 + columnWidth / 2, 1000 - 7 * 50 -20)
                    ctx.font = "normal 56px 'SF Pro Text'";
                    ctx.fillStyle = '#05241E'
                    // 分数数字显示 高于线50
                    ctx.fillText(element , 100 + columnWidth / 2 + j * columnWidth, 1000 - element * 50 - 20 - 40)
                    ctx.arc(100 + columnWidth / 2 + j * columnWidth , 1000 - 7 * 50 - 20, 4, 0, 2 * Math.PI)
                }else{
                    // 分数数字显示 高于线50
                    ctx.fillText(element  , 100 + columnWidth / 2 + j * columnWidth, 1000 - element * 50 - 20 - 40)
                    ctx.lineTo(columnWidth / 2 + j * columnWidth , 1000 - element * 50 - 20);
                    ctx.arc(100 + columnWidth / 2 + j * columnWidth , 1000 - element * 50 - 20, 4, 0, 2 * Math.PI)
                }
            });
            ctx.stroke();
            // Y轴
            // ctx.beginPath();
            // ctx.moveTo(100, 1000);
            // ctx.lineTo(100 , canvas.height - 1020);
            // ctx.stroke();
            // 分数刻度
            ctx.font = "normal 44px 'SF Pro Text'";
            ctx.textAlign = 'end'
            ctx.fillStyle = 'rgba(5, 36, 30, 0.4)'
            ctx.fillText("0" ,90, 1000)
            ctx.fillText("2" ,90, 900)
            ctx.fillText("4" ,90, 800)
            ctx.fillText("6" ,90, 700)
            ctx.fillText("8" ,90, 600)
            ctx.fillText("10" ,90, 500)
        },

        // 阅读指南弹框出现
        suspended(){
            this.guide_flag = !this.guide_flag
            if(this.guide_flag){
                document.body.style = "overflow:hidden";
                this.$refs.ceshi.style.top = this.scrollTop + "px"
            }else{
                document.body.style = ""
            }
        },

        // 答题情况弹框
        validAnswer(){
            this.effective_flag = !this.effective_flag
            if(this.effective_flag){
                document.body.style = "overflow:hidden";
                this.$refs.effective.style.top = this.scrollTop + "px"
                // 判断测试者时间判断测试者结果位置
                if(this.testerLimit < this.timeLimit/2){
                    this.$refs.testResult.style.left = (this.testerLimit/this.timeLimit)/2 * 100 + '%'
                }else if(this.testerLimit >= this.timeLimit/2 && this.testerLimit < this.timeLimit*2){
                    this.$refs.testResult.style.left = (this.testerLimit/(this.timeLimit*2)) * 100 + '%'
                }else if(this.testerLimit === this.timeLimit*2){
                    this.$refs.testResult.style.left = '85%'
                }else if(this.testerLimit > this.timeLimit*2){
                    this.$refs.testResult.style.left = (this.testerLimit - this.timeLimit*2)/100 + 90 + '%'
                }

                // 判断测评者题目完成量
                if(this.completion === 1){
                    this.$refs.testComplete.style.left ='100%'
                }else if(this.completion >= 0.97 && this.completion < 1){
                    this.$refs.testComplete.style.left = (this.completion - 0.97) * 100 * 15 + 60 + '%'
                }else if(this.completion < 0.97){
                    this.$refs.testComplete.style.left = this.completion * (40/96) * 100  + '%'
                }

                // 掩饰得分
                if(this.lieScore <= 10){
                    this.$refs.lieScore.style.left = this.lieScore * 10 + '%'
                }else{
                    this.$refs.lieScore.style.left = 100 + '%'
                }
            }else{
                document.body.style = ""
            }
        },

        // 数组对象排序
        compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value2 - value1;
            }
        },

        // 时间戳格式化
        formatDate(now) { 
            var year=now.getFullYear();  //取得4位数的年份
            var month=now.getMonth()+1;  //取得日期中的月份，其中0表示1月，11表示12月
            var date=now.getDate();      //返回日期月份中的天数（1到31）
            var hour=now.getHours();     //返回日期中的小时数（0到23）
            var minute=now.getMinutes(); //返回日期中的分钟数（0到59）
            var second=now.getSeconds(); //返回日期中的秒数（0到59）
            return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second; 
        },
    }
}
</script>
<style>
    p,div,ul,img{
        
        margin: 0;
        padding: 0;
    }
    ul {
        list-style: none;
    }
    /* 整个显示内容区域 */
    .container{
        min-width: 375px;
        width: 100%;
        height: 100%;
        max-width: 768px;
        overflow: hidden;
        margin: 0 auto;
    }
    /* 个人信息部分 */
    .header{
        width: 100%;
        padding-top: 15px;
        z-index: 1;
    }
    .header .title{
       text-align: center;
       font-size: 18px;
       font-weight: 500;
       color: #05241E
    }
    .header .content{
        text-align: center;
        font-size: 14px;
        color: #1AB394

    }
    /* 个人信息头像 */
    .header .avatar{
        width: 72px;
        height: 72px;
        display: block;
        border-radius: 50%;
        margin: 24px auto 5px;
        text-align: center;
    }
    /* 姓名 */
    .header .name{
        text-align: center;
        font-size: 24px;
        font-weight: 500;
        color: #05241E;
        
    }
    /* 综合指数评分 */
    .header .comprehensive{
        text-align: center;
        margin-top: 16px;
    }
    .header .comprehensive .mark{
        width: 90px;
        display: inline-block;
        position: relative;
    }
    .header .comprehensive .mark .mark_blank{
        width: 90px;
        top: -16px;
        position: absolute;
    }
    /* .header .comprehensive .mark .mark_full{
        top: -16px;
        word-break:keep-all; 
        white-space:nowrap;
        overflow: hidden;
        position: absolute;
    } */
    /* .header .comprehensive .mark .mark_full img, */
    .header .comprehensive .mark .mark_blank img{
        margin-top: 1px;
        width: 18px;
        height: 18px;
    }
    .header .comprehensive span{
        font-size: 14px
    }
    .header .suspended{
        position: fixed;
        z-index: 9;
        top: 28px;
        right: 0;
    }
    .header .suspended .answer,
    .header .suspended .guide{
        width: 80px;
        height: 32px;
        line-height: 32px;
        font-size: 12px;
        z-index: 99;
        border-radius: 16px 0 0 16px;
        box-shadow: 0px 3px 6px rgba(26, 179, 148, .3);
        text-align: center;
        color: #fff;
        background-color: #1AB394;
    }
    .mini{
        position: fixed;
        width: 80px;
        height: 32px;
        left: 0;
        margin-top: 100%;
        line-height: 32px;
        font-size: 12px;
        z-index: 99;
        border-radius:0px 16px 16px 0px;
        box-shadow:0px 3px 6px rgba(10,160,130,0.33);
        text-align: center;
        color: #fff;
        background-color: #1AB394;
    }
    .header .suspended .answer{
        margin-top: 16px;
    }
    /* 个人详细信息 */
    .info {
        padding: 0 16px 0 0px;
        margin: 0;
        margin-top: 25px;
        margin-bottom: 40px;
        text-align: center
    }
    .info li{
        border-right: 1px dashed #7C8C89
    }
    .info li:last-child{
        border-right: none
    }
    .info li{
        list-style: none;
        display: inline-block;
        width: 24%;
        height: 51px;
    }
    .info li div{
        float: left;
        font-size: 12px;
        color: #7C8C89;
        width: 100%;
        height: 60%;
    }
    .info li div:nth-child(2){
        position: relative;
        font-size: 14px;
        text-align: center;
        color: #05241E
    }
    .info li div:nth-child(2) .sex{
        box-sizing: border-box;
        padding: 0 5px;
        width: 100%;
        line-height: 15px;
        margin: 0;
    }
    /* 指标及分析部分 */
    .main{
        width: 100%;
        background-color: #F2F2F2;
        display: block;
        position: relative;
    }
    .main .main_bgc1{
        position: absolute;
        width: 5px;
        height: 5px;
        top: 90px;
        left: 45px;
        border-radius: 50%;
        opacity: 0.3;
        box-shadow: 0px 0px 45px 65px #F08597;
        background-color: #F08597
    }
    .main .main_bgc3{
        position: absolute;
        width: 5px;
        height: 5px;
        top: 530px;
        right: 55px;
        border-radius: 50%;
        opacity: 0.3;
        box-shadow: 0px 0px 45px 65px #F57953;
        background-color: #F57953
    }
    .main .main_bgc4{
        position: absolute;
        width: 5px;
        height: 5px;
        top: 860px;
        left: 32%;
        border-radius: 50%;
        opacity: 0.3;
        box-shadow: 0px 0px 45px 100px #86A0EE;
        background-color: #86A0EE
    }
    /* 一级指标 */
    .main .first_content{
        text-align: center;
        position: relative;
    }
    .main .first_content .title{
        padding-top: 24px;
        font-size: 17px;
        font-weight: 500;
        text-align: center;
        color: #05241E
    }
    .main .first_content .radar{
        width: 100%;
        height: 408px;
        margin: 16px auto 0;
        border-radius: 25px;
        padding-top: 16px;
        position: relative;
        background-color: #fff
    }
    .main .first_content .result{
        position: absolute;
        width: 108px;
        transform: translateX(6px);
        top: -26px;
        z-index: 9;
    }
    .main .first_content .radar .sore{
        position: absolute;
        width: 72px;
        height: 72px;
        top:0;
        right: 0;
        border-radius: 0 25px 0 15px;
        box-shadow: 0px 0px 7px 3px #f2f2f2;
        border: 1px solid #f2f2f2
    }
    .main .first_content .radar .sore .comprehensive{
        font-size: 12px;
        margin-top: 12px;
        margin-top: 12px;
        color: #05241E
    }
    .main .first_content .radar .sore .fraction{
        font-size: 24px;
        font-weight: 500;
        margin-top: 5px;
        color: #1AB394
    }
    .main .first_content .radar .chart{
        font-size: 14px;
        font-weight: 500;
        color: #05241E;
    }
    .main .first_content .radar .echarts_radar{
        margin: 44px auto 0;
    }
    .main .first_content .radar .echarts_radar div{
        text-align: center;
        width: 100%!important;
    }
    .echarts_explanation{
        height: 33px;
        width: 90%;
        margin: 24px auto 0;
        background-color: rgba(26, 179, 148, .1)
    }
    .echarts_explanation .average{
        width: 50%;
        text-align: center;
        line-height: 33px;
        display: inline-block
    }
    .average:nth-child(1) div:nth-child(1){
        width: 12px;
        height: 4px;
        margin-bottom: 3px;
        display: inline-block;
        background-color: #5D83EB
    }
    .average div:nth-child(2){
        font-size: 12px;
        padding-left: 10px;
        display: inline-block;
    }
    .average:nth-child(2) div:nth-child(1){
        width: 12px;
        height: 4px;
        margin-bottom: 3px;
        display: inline-block;
        background-color: #EB5D76
    }
    /* 二级指标 */
    .main .second_content{
        position: relative;
        z-index: 1;
    }
    .main .second_content .second_all{
        width: 100%;
        border-radius: 20px;
        margin: 16px auto;
        padding-top: 16px;
        padding-bottom: 15px;
        overflow:hidden;
        background-color: #fff;
    }
    .main .second_content .second_title{
        font-size: 14px;
        font-weight: 500;
        text-align: center;
    }
    .main .second_content .second_echarts{
        height: 278px;
        width: 90%;
        margin: 0px auto;
        overflow:scroll
    }
    .second_details{
        width: 100%;
        border-radius: 20px;
        margin: 16px auto;
        padding-top: 16px;
        overflow:hidden;
        background-color: #fff;
    }
    .second_details .second_explanation{
        font-size: 14px;
        font-weight: 500;
        text-align: center;
    }
    .communication{
        width: 100%;
        margin: 10px auto;
        overflow: hidden;
    }
    .communication-shadow{
        width: 100%;
        padding-bottom: 8px;
        box-shadow:0px 2px 6px rgba(155,177,204,0.16);
    }
    .communication-shadow .mint-navbar{
        width: 90%;
        height: 100%;
        margin: 0px auto 0;
        background-color: #fff;
        display: block;
        white-space: nowrap;
        overflow: scroll;
    }
    .main .second_content .second_echarts::-webkit-scrollbar,
    .mint-navbar::-webkit-scrollbar {
        display: none;
    }
    .communication-shadow .mint-navbar a{
        margin-top: 15px;
    }
    .communication-shadow .mint-navbar .mint-tab-item{
        height: 100%;
        margin-right:16px;
        display: inline-block!important;
        padding: 0!important;
    }
    .communication-shadow .mint-navbar .mint-tab-item.is-selected{
        border-bottom:none!important;
        margin-bottom: 3px!important;
    }
    .communication-shadow .mint-navbar .mint-tab-item.is-selected .mint-tab-item-label .second_score{
        color: #1AB394
    }
    .communication-shadow .mint-tab-item-label{
        color: rgba(0, 0, 0, 0.5)!important;
        font-size: 14px!important;
    }
    .communication-shadow .mint-tab-item.is-selected .mint-tab-item-label{
        color: rgba(0, 0, 0, 1)!important
    }
    .communication-shadow .mint-tab-container{
        margin-top: 10px;
    }
    .detail{
        padding-bottom: 16px;
        width: 92%;
        margin: 10px auto 0;
        border-bottom: 1px solid #F0F0F0;
    }
    .detail:last-child{
        border-bottom: none
    }
    .detail .tab_score{
        margin-left: 5%;
        font-size:14px;
        font-weight:600;
        line-height:20px;
    }
    .detail .tab_content{
        text-align: center
    }
    .detail .tab_content .score{
        font-size:12px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:17px;
        position: relative;
        color:rgba(5,36,30,1);
    }
    .detail .tab_content .tab_chart1{
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
    }
    .tab_both{
        width: 80%;
        height: 25px;
        font-size: 11px;
        color: #BBBBBB;
        line-height: 25px;
        margin: 0 auto;
    }
    .tab_both div:first-child {
        float: left;
        
    }
    .tab_both div:last-child{
        float: right;
    }
    .property{
        width: 90%;
        margin: 5px auto
    }
    .property .low{
        padding-right: 10px;
        border-right: 1px solid #BBBBBB
    }
    .property .high{
        box-sizing: border-box;
        padding-left: 10px;
    }
    .property .low,
    .property .high{
        width: 45%;
        color: #717171;
        vertical-align: top;
        font-size:12px;
        line-height:16px;
        text-align:justify;
        display: inline-block;
    }
    .conclusion{
        width: 85%;
        text-align: justify;
        margin: 0 auto
    }
    .conclusion .conclus,
    .conclusion .conclus_content{
        color: #05241E;
        display: inline;
    }
    .conclusion .conclus{
        font-size: 15px;
        font-weight: 600;
    }
    .conclusion .conclus_content{
        font-size: 13px;
        font-weight: 400;
    }
    /* 分析与建议 */
    .third_content{
        position: relative;
    }
    .third_content .third_title{
        font-size: 17px;
        font-weight: 500;
        color: #05241E;
        text-align: center
    }
    .third_content .bgc5{
        position:absolute;
        width: 5px;
        height: 5px;
        left: 50%;
        border-radius: 50%;
        opacity: 0.2;
        box-shadow: 0px 0px 45px 65px #1AB394;
        background-color: #1AB394;
    }
    .third_content .thirdContent{
        position: relative;
        width: 100%;
        margin-top: 16px;
        padding-bottom: 30px;
        border-radius: 15px 15px 0 0;
        box-sizing: border-box;
        background-color: #fff;
    }
    .thirdContent .thirdContent_shadow{
        padding:10px 0;
        box-shadow: 0px 2px 6px rgba(157,177,204,0.16);
    }
    .thirdContent_shadow .mint-navbar{
        width: 100%;
    }
    .thirdContent_shadow .mint-tab-item{
        padding: 0;
        opacity: .5;
        color: #05241E;
    }
    .thirdContent_shadow .mint-tab-item-label{
        font-size: 14px!important
    }
    .thirdContent_shadow .mint-navbar .mint-tab-item{
       padding: 0!important 
    }
    .thirdContent_shadow .mint-tab-item.is-selected{
        padding: 0;
        opacity: 1;
        color: #05241E!important;
        border-bottom: none!important
    }
    .thirdContent .th_content{
        width: 85%;
        margin: 10px auto
    }
    .mint-tab-container-item:nth-child(2) .thirdContent_tilte{
        color: #EB5D76
    }
    .thirdContent_detail{
        font-size: 13px;
        margin-top: 10px;
        text-align: justify
    }
    .thirdContent_tilte{
        font-weight: 500;
        font-size: 15px;
        color: #1AB394
    }
    /* 答题情况 / 阅读指南 */
    .answers,
    .readingguide{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        max-width: 768px;
        min-width: 375px;
        z-index: 9999;
        background-color:rgba(0, 0, 0, .2);
    }
    .answers .down,
    .readingguide .down{
        width: 100%;
        height: 44px;
        line-height: 44px;
        margin-top: 32px;
        border-radius: 20px 20px 0 0;
        background-color: #F0F0F0;
        text-align: center
    }
    .answers .down img,
    .readingguide .down img{
        width: 18px;
    }
    .answers .readingguide_explanation,
    .readingguide .readingguide_explanation{
        width: 100%;
        height: 95%;
        padding: 16px 24px 50px 24px;
        overflow: scroll;
        box-sizing: border-box;
        background-color: #fff;
    }

    .answers .explanation_title,
    .readingguide .explanation_title{
        width: 100%;
        font-size: 20px;
        font-weight: 500;
        padding-bottom: 4px;
        color: #05241E;
        border-bottom: 1px solid #7C8C89;
        text-align: center
    }

    .readingguide .recommendations,
    .readingguide .introduction,
    .answers .introduction{
        width: 100%;
        font-size: 15px;
        font-weight: 500;
        margin-top: 8px;
        color: #05241E;
        text-align: center
    }
    .answers .introduction{
        padding-bottom: 8px;
    }
    .readingguide .introduction_content{
        font-size: 14px;
        padding-bottom: 24px;
        border-bottom: 1px solid #EBEBEB;
        color: #05241E
    }
    .readingguide .recommendations{
        margin-top: 24px;
    }
    .readingguide .recommendations_content{
        margin-top: 4px;
    }
    .readingguide .recommendations_content .tabel{
        width: 100%;
        margin-top: 8px
    }
    .readingguide .recommendations_content p{
        font-size: 14px;
        color: #05241E
    }
    .readingguide .recommendations_content .grade_word{
        color: #1AB394
    }
    .readingguide .grade1,
    .readingguide .grade{
        height: 115px;
        width: 17.2%;
        box-sizing: border-box;
        float: left;
        border-top: 1px solid #1AB394;
        border-bottom: 1px solid #1AB394;
    }
    .readingguide .grade:nth-child(1){
        line-height: 28px;
        width: 14%;
        color: #fff;
        background-color: #1AB394!important
    }
    .readingguide .grade1 div,
    .readingguide .grade div{
        width: 100%;
        height: 50%;
        font-size: 12px;
        text-align: center
    }
    .readingguide .grade1:nth-child(even),
    .readingguide .grade:nth-child(odd){
         background-color: #E7F7F4 
    }
    .readingguide .grade1:nth-child(even) div:first-child,
    .readingguide .grade:nth-child(odd) div:first-child{
         border-bottom: 1px solid #fff
    }
    .readingguide .grade1:nth-child(odd) div:first-child,
    .readingguide .grade:nth-child(even) div:first-child{
         border-bottom: 1px solid #E7F7F4
    }
    .readingguide .grade1:last-child div:first-child,
    .readingguide .grade:nth-child(1) div:first-child{
        border-bottom: 1px solid #fff
    }
    .readingguide .grade1:nth-child(n+1) div,
    .readingguide .grade:nth-child(n+2) div{
        line-height: 56px;
    }
    .readingguide .grade1{
        margin-top: 6px;
    }
    .readingguide .grade1:last-child{
        width: 14%;
    }
    .readingguide .grade1:last-child div{
        line-height: 28px;
        color: #fff;
        background-color: #1AB394!important
    }
    .answers .introduction_content{
        font-size: 14px;
        padding-bottom: 24px;
        color: #05241E
    }

    /* 测评结果分析 */
    .slider{
        box-sizing: border-box
    }
    .slider .lie,
    .slider .question,
    .slider .answer_time{
        width: 90%;
        height: 50px;
        margin: 0 auto;
        box-sizing: border-box;
        position: relative;
    }
    .slider .lie .lie_title,
    .slider .question .question_title,
    .slider .answer_time .answer_word{
        float: left;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        text-align: center;
        width: 30%;
        height: 100%;
    }
    .slider .lie .lie_con,
    .slider .question .question_con,
    .slider .answer_time .time{
        width: 70%;
        line-height: 40px;
        padding-top: 10px;
        box-sizing: border-box;
        display: inline-block
    }
    .slider .lie .lie_con .lie_interval,
    .question .question_con .question_interval,
    .slider .answer_time .time .interval{
        width: 100%;
        height: 2px;
        background-color: #EBEBEB;
    }
    .slider .answer_time .time .interval .validInterval{
        width: 60%;
        height: 100%;
        margin-left: 25%;
        background-color:#1AB394
    }
    .lie .lie_con .lie_effectiveTime,
    .question .question_con .question_effectiveTime,
    .slider .answer_time .time .effectiveTime{
        width: 100%;
        font-size: 11px;
        color: #05241E
    }
    .slider .answer_time .time .effectiveTime .effective_star {
        display: inline;
        margin-left: 20%
    }
    .slider .answer_time .time .effectiveTime .effective_stop {
        /* display: inline-block; */
        float: right;
        margin-right: 8%
    }
    .lie .lie_con .lieSc,
    .question .question_con .testerComp,
    .slider .answer_time .litigant{
        width: 2px;
        height: 16px;
        top: -50px;
        position: relative;
        background-image: linear-gradient(rgba(245, 66, 82, .1), rgba(245, 66, 82, 1), rgba(245, 66, 82, .1));
    }

    .question .question_con .question_effectiveTime .question_effective_star{
        display: inline;
        margin-left: 58%
    }
    .question .question_con .question_effectiveTime .question_effective_stop{
        /* display: inline-block; */
        float: right;
        margin-right: 0%
    }
    .question_con .question_interval .question_validInterval{
        width: 40%;
        height: 100%;
        margin-left: 60%;
        background-color:#1AB394
    }
    .lie_interval .lie_validInterval{
        width: 80%;
        height: 100%;
        margin-left: 0%;
        background-color:#1AB394
    }
    .lie .lie_con .lie_effectiveTime .lie_effective_start{
        display: inline;
        margin-left: 0%
    }
    .lie .lie_con .lie_effectiveTime .lie_effective_stop{
        /* display: inline-block; */
        float: right;
        margin-right: 17%
    }
    .parameter {
        width: 100%;
        height: 33px;
        margin-top: 16px;
        background-color: #FAFAFA
    }
    .parameter .average{
        width: 50%;
        line-height: 33px;
        text-align: center;
        float: left;
    }
    .parameter .average:first-child div:first-child{
        height: 2px;
        background-color: #1AB394
    }
    .parameter .average:last-child div:first-child{
        height: 2px;
        background-color:#EB5D76
    }
    .answers{
        position: absolute;
        top: 0
    }
    .answers .effectiveness{
        width: 100%;
        height: 36px;
        line-height: 36px;
        margin-top: 24px;
        text-align: center;
        background-color: rgba(26, 179, 148, .1)
    }
    .answers .effectiveness span:first-child{
        font-size: 12px;
        color: #7C8C89
    }
    .answers .effectiveness span:last-child{
        font-size: 14px;
        font-weight: 500;
        color: #1AB394
    }
    .ansewrTime{
        width: 100%;
        margin-top: 32px;
        font-size: 15px;
        font-weight: 500;
        color: #05241E;
        text-align: center
    }
    .form{
        margin-top: 16px;
    }
    .form .form_body,
    .form .form_head{
        width: 100%;
        height: 33px;
        line-height: 33px;
        border-radius: 16px;
        color: #FCFFFE;
        background-color:#1AB394
    }
    .form .form_head div:first-child{
        width: 16%!important;
    }
    .form .form_head div{
        width: 28%;
        height: 100%;
        font-size: 12px;
        float: left;
        text-align: center
    }
    .form .form_body div:first-child{
        width: 16%!important;
    }
    .form .form_body div{
        width: 28%;
        height: 100%;
        font-size: 12px;
        float: left;
        text-align: center
    }

    .form .form_body:nth-child(even){
        color: #05241E;
        background-color: #fff;
    }
    .form .form_body:nth-child(odd){
        color: #05241E;
        background-color:rgba(26, 179, 148, .1)
    }
    .form .form_body div:nth-child(3){
        font-weight: 500px;
        color: #1AB394
    }

    /* 加载中 */
    .el-loading-mask{
        background-color: rgba(255,255,255,1);
    }
    .el-loading-spinner .el-loading-text{
        color: #7C8C89!important
    }
    .el-loading-spinner .path{
        stroke: #7C8C89!important;
    }
</style>
